import React from 'react';
import { IProps as IStoriesDetailLayoutProps } from './StoriesDetailLayout.interface';
import { StoriesDetailLayout } from './StoriesDetailLayout.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IStoriesDetailLayoutInputProps {
  leftMenu?: any;
  [key: string]: any; // For BlockWrapper props
}

const mapInputToProps = (
  input: IStoriesDetailLayoutInputProps,
): IStoriesDetailLayoutProps => {
  const { leftMenu, mainComponents } = input;
  return {
    ...input,
    left: leftMenu
      ? [
          {
            name: leftMenu.name || 'MetaDataBlock',
            props: {
              alignment: 'vertical',
              backgroundColor: 'primary-0',
              ...leftMenu.props,
            },
          },
        ]
      : undefined,
    right: mainComponents || undefined,
    layout: 'right',
  };
};

const StoriesDetailLayoutTranslation: React.FC<
  IStoriesDetailLayoutInputProps
> = (inputProps) => (
  <TranslationComponent
    inputProps={inputProps}
    TargetComponent={StoriesDetailLayout}
    mapProps={mapInputToProps}
  />
);

export default StoriesDetailLayoutTranslation;
